import React, { useState, useEffect, useRef } from 'react';
import Input from '../Input';
import Dropdown from '../Dropdown';
import closeIcon from '../../Assets/Icons/close.png';
import pluseIcon from '../../Assets/Icons/Pluse.png';
import uploadIcon from '../../Assets/Icons/upload.png';
import TextInput from '../TextInput';
import search from '../../Assets/Icons/search.png';
import Loader from '../Loader';
import { postData, getData } from '../../ApiServices/ApiService';
import { ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, ORG_CONFIGURATION_CONTACT_CENTER } from '../../ApiServices/BaseURL';
import { useTheme } from "../../GlobalContext/GlobalContext";
import { logFrontendException } from '../../Utils/Exception';
import downArrow from '../../Assets/Icons/chevron-down.png';
import DeleteConfirmationModal from './DeleteConformationModal'


const ConfigurationCreateNewListModal = ({ isOpen, onClose, onRefresh, documentData, setSelectedDocument,handleRefreshAllTabs }) => {

  const [userName, setUserName] = useState('');
  const [channel, setChannel] = useState('');
  const [api, setApi] = useState('');
  const [password, setPassword] = useState('');
  const [listName, setListName] = useState('');
  const [selectedClient, setSelectedClient] = useState(null);
  const [searchUser, setSearchUser] = useState('');
  const { setIsLoginPopup } = useTheme();
  const pageName = "ConfigurationCreateNewListModal";

  const [showUpload, setShowUpload] = useState(false);
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef(null);

  // useEffect(() => {
  //   if (clientName || clientType || identificationType || identificationNumber || groupClient || mobileNumber) {
  //     setShowUpload(true);
  //   } else {
  //     setShowUpload(false);
  //   }
  // }, [clientName, clientType, identificationType, identificationNumber, groupClient, mobileNumber]);

  // Reset form fields to initial values
  const resetForm = () => {
    setAddContactSuccess('');
    setAddContactError('')
    setListName('');
    setContactsInList('')
    setSearchUser('')
    setSelectedContact(null);
    setListError('');
    setSelectedDocument(null);
    setCheckContactError('');
  };

  // Run resetForm when modal closes
  useEffect(() => {
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  // Handle file input change
  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      //console.log("Uploaded file:", files[0]);
      // Handle file upload here (e.g., upload to server or process locally)
    }
  };

  // Trigger file input click
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const groupClientOptions = ["Active", "In Active"];
  const [groupClient, setGroupClient] = useState('');
  const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const dropdownRefs = useRef({}); // Ref for dropdown

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = Object.keys(dropdownRefs.current).every(
        (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
      );
      if (isOutside) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [contactError, setContactError] = useState('');
  const [contactLoading, setContactLoading] = useState(false);
  const [contactNames, setContactNames] = useState([]);
  const handleContactsSearch = async () => {
    try {
      setContactError('');
      setContactLoading(true);
      setContactNames([]);
      if (!searchUser) {
        setContactError('Please enter valid text'); return;
      }
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = { emp_id_auth: storedUserInfo?.emp_id, action_type: "search_contact_list", search_word: searchUser }

      console.log('list Data', payLoad);
      // return
      // Make the API call
      const response = await postData(ORG_CONFIGURATION_CONTACT_CENTER, payLoad);
      const responseData = await response.json();
      //console.log('response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.status_code === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setContactNames(responseData?.dataJ || []);
            // setSuccess(responseData?.info);
            setTimeout(() => {
              // handleClose();
              // onValueChange();
            }, 3000);
          } else {
            setContactError(responseData?.info || 'Failed to fetch Client. Please try again.');
          }
        } else {
          setContactError(responseData?.info || 'Failed to fetch Client.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setContactError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setContactError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
        setIsLoginPopup(true)
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setContactError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setContactError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setContactError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Client. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setContactError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setContactError(`Something went wrong while processing your request. Please check your network connection and try again.`);
      }
    } finally {
      setContactLoading(false);
    }
  };

  const [selectedContact, setSelectedContact] = useState(null);
  const handleSelectlist = (client) => {
    setSelectedContact(client); // Set selected client data
    setSearchUser(client?.contact_name);
    // setSearchUser(`${client?.contact_name} (${client?.communication_channel})`);
    setContactNames([]); // Clear the dropdown
    // setSelectedClientError('');
  };

  const [contactsInList, setContactsInList] = useState([]);
  const [duplicateMessage, setDuplicateMessage] = useState('');

  const handleAddToList = () => {
    setDuplicateMessage('')
    if (!selectedContact) return;

    const alreadyExists = contactsInList.some(c => c.contact_id === selectedContact.contact_id);

    if (alreadyExists) {
      setDuplicateMessage('Contact already added to the list');
      // setTimeout(() => setDuplicateMessage(''), 3000);
      return;
    }

    setContactsInList(prev => [...prev, selectedContact]);
    setSelectedContact(null);
    setSearchUser('');
    setDuplicateMessage('');
  };

  const [addContactLoading, setAddContactLoading] = useState(false);
  const [addContactError, setAddContactError] = useState('');
  const [addContactSuccess, setAddContactSuccess] = useState('');
  const [listError, setListError] = useState('');
  const addNewList = async () => {
    setAddContactLoading(true);
    const storedUserId = JSON.parse(localStorage.getItem('_userInfo_'));
    setListError('');
    setAddContactError('');
    setDuplicateMessage('');
    setCheckContactError('');
    try {
      // if (!channel) {
      //   setChannelNameError('Please select channel'); return;
      // }
      if (!listName) {
        setListError('Please select list name'); return;
      }
      console.log("Payload to new list submit:");

      const payload = {
        emp_id_auth: storedUserId?.emp_id || 0,
        list_name: listName,
        "action_type": 'add_list_name',
        contacts: contactsInList?.map(contact => ({
          contact_name: contact.contact_name,
          communication_channel: contact.communication_channel?.toLowerCase() || '',
          contact_no: contact.contact_no || null,
          whatsapp_no: contact.whatsapp_no || null,
          email_id: contact.communication_channel?.toLowerCase() === 'email' ? contact.email_id || null : null,
          opt_out: contact.opt_out === 'Yes' || contact.opt_out === 1 ? 1 : 0,
          client_id: contact.client_id || null
        }))
      };


      console.log("Payload to new list submit:", payload);
      const response = await postData(ORG_CONFIGURATION_CONTACT_CENTER, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          setAddContactSuccess(responseData?.info);
          setTimeout(() => {
            onRefresh();
            onClose();
            resetForm('');
            setAddContactSuccess('');
            handleRefreshAllTabs();
          }, 3000);
        } else {
          setAddContactError(responseData?.info || "Failed to fetch  SMS list.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || '');
        }
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setAddContactError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || response || '');

      } else {
        setAddContactError(responseData?.info || "Failed to fetch  SMS list.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || response || '');
      }
    } catch (err) {
      setAddContactError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "fetchSMSList-catch", err || '');
    } finally {
      setAddContactLoading(false);
    }
  };

  const editNewList = async () => {
    setAddContactLoading(true);
    const storedUserId = JSON.parse(localStorage.getItem('_userInfo_'));
    setListError('')
    setAddContactError('');
    setDuplicateMessage('');
    setCheckContactError('');
    try {
      // if (!channel) {
      //   setChannelNameError('Please select channel'); return;
      // }
      if (!listName) {
        setListError('Please select list name'); return;
      }
      console.log("Payload to new list submit:");

      const payload = {
        emp_id_auth: storedUserId?.emp_id || 0,
        list_name: listName,
        list_id: documentData.list_id,
        "action_type": 'update_communication_list',
        contacts: contactsInList?.map(contact => ({
          contact_name: contact.contact_name,
          contact_id: contact.contact_id,
          communication_channel: contact.communication_channel?.toLowerCase() || '',
          contact_no: contact.contact_no || null,
          whatsapp_no: contact.whatsapp_no || null,
          email_id: contact.communication_channel?.toLowerCase() === 'email' ? contact.email_id || null : null,
          opt_out: contact.opt_out === 'Yes' || contact.opt_out === 1 ? 1 : 0,
          client_id: contact.client_id || null
        }))
      };


      console.log("Payload to new list submit:", payload);
      const response = await postData(ORG_CONFIGURATION_CONTACT_CENTER, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          setAddContactSuccess(responseData?.info);
          setTimeout(() => {
            onRefresh();
            onClose();
            resetForm('');
            setAddContactSuccess('');
            handleRefreshAllTabs();
          }, 3000);
        } else {
          setAddContactError(responseData?.info || "Failed to fetch  SMS list.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || '');
        }
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setAddContactError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || response || '');

      } else {
        setAddContactError(responseData?.info || "Failed to fetch  SMS list.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || response || '');
      }
    } catch (err) {
      setAddContactError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "fetchSMSList-catch", err || '');
    } finally {
      setAddContactLoading(false);
    }
  };

  useEffect(() => {
    if (documentData && isOpen) {
      setListName(documentData.list_name || '');
      setContactsInList(documentData.contacts || []);
    }
  }, [documentData, isOpen]);

  const [checkContactLoading, setCheckContactLoading] = useState(false);
  const [checkContactError, setCheckContactError] = useState('')
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('');
  const checkContactInOtherList = async (forceDelete = false) => {
    setCheckContactLoading(true);
    const storedUserId = JSON.parse(localStorage.getItem('_userInfo_'));
    setCheckContactError('')
    setDuplicateMessage('')
    try {
      if (!searchUser) {
        setCheckContactError('Please select contact'); return;
      }
      // console.log("Payload to new list contact check:",selectedContact);

      const payload = {
        emp_id_auth: storedUserId?.emp_id || 0,
        list_name: listName,
        "action_type": 'check_contact_exist',
        "force_delete": forceDelete,
        contacts: [
          {
            contact_name: selectedContact?.contact_name,
            communication_channel: selectedContact?.communication_channel?.toLowerCase() || '',
            contact_no: selectedContact?.contact_no || null,
            whatsapp_no: selectedContact?.whatsapp_no || null,
            email_id: selectedContact?.communication_channel?.toLowerCase() === 'email'
              ? selectedContact.email_id || null
              : null,
            opt_out: selectedContact?.opt_out === 'Yes' || selectedContact?.opt_out === 1 ? 1 : 0,
            client_id: selectedContact?.client_id || null,
          }
        ]
      };


      console.log("Payload to new list contact check:", payload);
      // return
      const response = await postData(ORG_CONFIGURATION_CONTACT_CENTER, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          handleAddToList();
          handleRefreshAllTabs();
          // setTimeout(() => {
          //     onRefresh();
          //     onClose();
          //     resetForm('');
          //     setAddContactSuccess('');
          //   }, 3000);
        } else if (responseData.message.toLowerCase() === "confirm_required") {
          setConfirmationMessage(responseData.info);
          setShowConfirmationModal(true);
          return;
        } else {
          setCheckContactError(responseData?.info || "Failed to fetch  SMS list.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || '');
        }
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setCheckContactError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || response || '');

      } else {
        setCheckContactError(responseData?.info || "Failed to fetch  SMS list.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || response || '');
      }
    } catch (err) {
      console.log("Api Error", err);
      setCheckContactError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "checkContactInOtherList-catch", err || '');
    } finally {
      setCheckContactLoading(false);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; // Number of items per page
  const totalPages = Math.ceil(contactsInList?.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentContacts = contactsInList?.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const maxVisiblePages = 3;

  const getVisiblePages = () => {
    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust startPage if we're near the end
    const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

    return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
  };

  const visiblePages = getVisiblePages();



  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={() => { resetForm(); onClose(); }}>
          <img src={closeIcon} alt="Close" style={styles.iconImage} />
        </button>
        <h2 className="modal-title"> {documentData ? `Update List` : 'Create New List'}</h2>
        <hr className="title-divider" />
        {/* <div className="form-grid"> */}
        <div style={styles.formGrid}>
          <div className="filter-field" style={{ width: '240px' }}>
            <Input
              label="List Name"
              placeholder="Name"
              value={listName}
              onChange={(e) => setListName(e.target.value)}
              errorMessage={listError}
            />
          </div>
        </div>
        <div className="filter-field">
          <label
            style={{
              ...styles.labaleStyle,
              display: 'block',
            }}
          >
            Add Contact
          </label>
          <TextInput
            type="text"
            placeholder="Add Contact"
            value={searchUser}
            onChange={(e) => setSearchUser(e.target.value)}
            onRightClick={handleContactsSearch}
            right={
              contactLoading ? (
                <Loader loading={contactLoading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
              ) : (
                <img src={search} alt="Search" style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
              )
            }
            style={{ padding: '20px 10px' }}
            searchBoxWidth={240}
            errorMessage={contactError}
          />
          {contactNames.length > 0 && (
            <ul style={styles.dropdownList}>
              {contactNames.map((client, index) => (
                <li
                  key={client?.client_id}
                  onClick={() => handleSelectlist(client)}
                  style={{
                    ...styles.dropdownItem,
                    borderBottom: index !== contactNames?.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                  }}
                >
                {client?.contact_name} ({client?.communication_channel}) {client?.communication_channel === "email"
              ? client?.email_id
              : client?.communication_channel === "whatsapp"
              ? client?.whatsapp_no
              : client?.communication_channel === "phone"
              ? client?.contact_no
              : ""}
                </li>
              ))}
            </ul>
          )}

        </div>
        <button style={{ ...styles.addServiceButton, marginBottom: '15px' }} onClick={() => checkContactInOtherList(false)}>
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: "10px" }}>+</span>
            <span>Add to list</span>
            {checkContactLoading && (
              <span style={{ marginLeft: '8px' }}>
                <Loader loading={checkContactLoading} color={'var(--background-color)'} size="small" />
              </span>
            )}
          </span>
        </button>
        {checkContactError && (
          <div className="list-error-msg">
            {checkContactError}
          </div>
        )}
        <div style={styles.tableWrapper}>
          <table className="tasksScreen-task-table">
            <thead>
              <tr>
                <th style={{ width: "20%" }}>Contact Name</th>
                <th style={{ width: "20%" }}>Contact Type</th>
                <th style={{ width: "20%" }}>Phone No</th>
                <th style={{ width: "20%" }}>File Number</th>
              </tr>
            </thead>
            <tbody style={{ backgroundColor: "white" }}>
              {currentContacts?.map((contact, index) => (
                <tr key={index}>
                  <td style={styles.tableValue}>{contact?.contact_name}</td>
                  <td style={styles.tableValue}>{contact?.communication_channel}</td>
                  <td style={styles.tableValue}>{contact?.contact_no || contact?.whatsapp_no}</td>
                  <td style={styles.tableValue}>{contact?.client_file_ids}</td>

                </tr>
              ))}
            </tbody>
          </table>
          {duplicateMessage && (
            <div className="list-error-msg">
              {duplicateMessage}
            </div>
          )}
        </div>
        <div className="tasksScreen-table-footer">
          <span className="tasksScreen-pagination-info">
            {`${currentPage}-${totalPages} of items`}
          </span>
          <div className="tasksScreen-pagination">
            <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1 || totalPages === 0}>
              <img src={downArrow} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image " />
            </button>
            {/* {[...Array(totalPages)].map((_, index) => (
                        <button key={index} className={`tasksScreen-pagination-button ${currentPage === index + 1 ? 'active' : ''}`} onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
                    ))} */}
            {/* Page Numbers */}
            {visiblePages.map((page) => (
              <button
                key={page}
                className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </button>
            ))}
            <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>
              <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image " />
            </button>
          </div>
        </div>
        <hr className="footer-divider" />

        <div className="button-container">
          <button
            className="add-client-button"
            onClick={documentData ? editNewList : addNewList}
            disabled={addContactLoading}
            style={{
              paddingLeft: '30px',
              paddingRight: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px', // Add spacing between text and loader
              position: 'relative',
              opacity: addContactLoading ? 0.5 : 1, // Reduce opacity when loading
              cursor: addContactLoading ? 'not-allowed' : 'pointer',
            }}
          >
            <span>{documentData ? 'Update' : 'Add'}</span>
            {addContactLoading && (
              <Loader loading={addContactLoading} color={'var(--background-color)'} size="small" />
            )}
          </button>
          <button className="cancel-button" onClick={() => { resetForm(); onClose(); }}>Cancel</button>
          {addContactError && <div className="list-error-msg" style={{ marginBottom: '1px' }}>{addContactError} </div>}
          {addContactSuccess && <div className="list-success-msg" style={{ marginBottom: '1px' }}>{addContactSuccess} </div>}
        </div>
      </div>
      <DeleteConfirmationModal
        isOpen={showConfirmationModal}
        message={confirmationMessage}
        onClose={() => setShowConfirmationModal(false)}
        onConfirm={() => {
          setShowConfirmationModal(false);
          checkContactInOtherList(true); // Call again with force_delete = true
        }}
      />
    </div>
  );
};

const styles = {
  uploadContainer: {
    marginTop: '20px',
    width: '97%',
  },
  uploadBox: {
    width: '100%',
    border: '1px dashed var(--web-title-text-color)',
    borderRadius: '10px',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
    boxSizing: 'border-box',
    position: 'relative', // Position relative to contain the hidden input
  },
  uploadCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    backgroundColor: '#f0f0f0',
  },
  plusIcon: {
    fontSize: '16px',
    color: '#333',
  },
  uploadText: {
    flex: 1,
    color: '#262626',
    fontSize: '12px',
    fontFamily: 'Roboto',
    fontWeight: 400
  },
  uploadArrow: {
    fontSize: '18px',
    color: '#555',
  },
  fileInput: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
    cursor: 'pointer',
  },
  iconImage: {
    width: '11px',
    height: '11px',
  },
  uploadIconImage: {
    width: '25px',
    height: '25px',
    marginRight: '5px'
  },
  exisitingHeading: {
    color: '#343C44',
    fontSize: '10px',
    fontWeight: 500,
    fontFamily: 'Roboto'
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr", // Single-column layout by default
    gap: "20px", // Space between rows
    marginBottom: "15px",
  },
  halfWidth: {
    gridColumn: "span 1",
    width: "48%", // Half width
    marginRight: "auto", // Aligns left
    marginBottom: '17px'
  },
  fullWidth: {
    gridColumn: "span 2",
    width: "97.5%", // Full width
  },
  row: {
    display: "flex",
    // justifyContent: "space-between",
    columnGap: "80px", // Space between dropdowns
    marginBottom: "15px",
    marginRight: "auto",
    width: "100%"
  },
  labaleStyle: {
    fontSize: '12px',
    // marginBottom: '5px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    color: 'rgb(52, 60, 68)'
  },
  addServiceButton: {
    backgroundColor: "transparent",
    border: "1px #858585 solid",
    borderRadius: "5px",
    padding: "8px 12px",
    color: "#40513B",
    cursor: "pointer",
    fontSize: '12px',
    fontFamily: 'Roboto',
    fontWeight: '400',
    borderRadius: '28px',
    marginLeft: '15px'
  },
  dropdownList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: '4px',
    maxHeight: '200px',
    overflowY: 'auto',
    zIndex: 1000,
    padding: 0, // Remove default padding
    margin: 0, // Remove default margin
    listStyleType: 'none', // Remove the dots
  },
  dropdownItem: {
    padding: '10px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee', // Default for all items
    backgroundColor: '#fff',
    hover: {
      backgroundColor: '#f0f0f0',
    },
  },
  tableWrapper: {
    overflowX: "auto", // Horizontal scroll
    whiteSpace: "nowrap", // Prevent table from wrapping on small devices
    // marginBottom:50
  },
}

export default ConfigurationCreateNewListModal;